module.exports = __webpack_public_path__ + "img/friend.a79a32cf.svg";